<template>
  <div class="conteudo-com-departamentos" v-if="departamentos.length > 0">
    <div class="content mb-6">
      <p>Agora preciso que você me indique os departamentos do eContador correspondentes, preciso desta informação para separar as suas tarefas por setor!</p>
      <p>
        <b>Os departamentos que não forem selecionados eu irei criar de forma automática!</b>
      </p>
    </div>
    <div v-for="dp in departamentosPadraoFaltantes" :key="dp.id">
      <div class="columns">
        <div class="column is-narrow">
          <p><strong>{{dp.nome}}:</strong></p>
        </div>
        <div class="column"></div>
          <div class="column is-5">
            <div class="columns">
            <TrfSelect
              :options="selectableOptions[dp.id]"
              :idSelect="'select-'+dp.nome"
              @valueSelect="(value) => (setDpPadraoConfig(dp.id, value))"
              @clear="() => (setDpPadraoConfig(dp.id, null))"
              :placeholder="'Criar '+dp.nome"
              :ref="'select-'+dp.nome"
              :canClear="true"
              class="column m-0 p-0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content" v-else>
    <p>
      Epa! Parece que você não tem nenhum departamento cadastrado!
      <br/>
      Mas não precisa se preocupar, eu vou criar os departamentos para você
      poder utilizar o eTarefas aqui!
    </p>
    <p>
      Ao concluir, os departamentos:
    </p>
    <ul>
      <li v-for="dp in departamentosPadraoFaltantes" :key="dp.id" class="has-text-weight-bold">{{dp.nome}}</li>
    </ul>
    <p>
      Já serão criados e vão ficar em Departamentos e categorias tá bem? E ainda vou configurar as tarefas padrão de cada um para você!<br/><br/>
      Bem legal, não é?
    </p>
  </div>
</template>

<script>
import TrfSelect from '../Select';
import { departamentoPadraoEnum } from '../../enums/departamentoPadraoEnum';

export default {
  name: "TrfWizardModuloDepartamentos",
  components: {
    TrfSelect
  },
  props: {
    departamentos: {
      type: Array,
      default: new Array()
    },
    departamentosPadraoFaltantes: {
      type: Array,
      required: true,
    },
    departamentosConfigurados: {
      type: Array,
      default: new Array()
    },
    departamentosNaoConfigurados: {
      type: Array,
      default: new Array()
    }
  },
  data() {
    return {
      configurados: this.departamentosConfigurados,
      naoConfigurados: this.departamentosNaoConfigurados,
      primeiroCarregamento: true
    };
  },
  emits: [ 'update:departamentosConfigurados', 'update:departamentosNaoConfigurados' ],
  methods: {
    preencherSelects() {
      if(this.primeiroCarregamento) {
        this.buscarMatchDpPadrao();
      }
      this.$nextTick(this.atualizarValoresSelects);
    },
    verificarMatch(casos = []) {
      for(let caso of casos) {
        const casoNormalizado = caso.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        if(this.naoConfigurados.some(dep => dep.label == caso)) {
          const index = this.naoConfigurados.findIndex(dep => dep.label == caso);
          return this.naoConfigurados[index].value;
        }
        
        if(this.naoConfigurados.some(dep => dep.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == casoNormalizado)) {
          const index = this.naoConfigurados.findIndex(dep => dep.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() == casoNormalizado);
          return this.naoConfigurados[index].value;
        }
      };

      return null;
    },
    buscarMatchDpPadrao() {
      let departamentoId = null;
      
      for(let dpFaltante of this.departamentosPadraoFaltantes) {
        let departamentoPadraoId = dpFaltante.id;

        switch(departamentoPadraoId) {          
          case(departamentoPadraoEnum.DEPARTAMENTO_PESSOAL.id):
            departamentoId = this.verificarMatch(["Departamento Pessoal", "DP"]);
            this.setDpPadraoConfig(departamentoPadraoId, departamentoId);
            break;
          case(departamentoPadraoEnum.CONTABIL.id):
            departamentoId = this.verificarMatch(["Contábil", "Departamento Contábil", "Contabilidade"]);
            this.setDpPadraoConfig(departamentoPadraoId, departamentoId);
            break;
          case(departamentoPadraoEnum.ESCRITA_FISCAL.id):
            departamentoId = this.verificarMatch(["Escrita Fiscal", "Fiscal", "Departamento Fiscal","Departamento Escrita Fiscal"]);
            this.setDpPadraoConfig(departamentoPadraoId, departamentoId);
            break;
          case(departamentoPadraoEnum.FINANCEIRO.id):
            departamentoId = this.verificarMatch(["Financeiro", "Departamento Financeiro"]);
            this.setDpPadraoConfig(departamentoPadraoId, departamentoId);
            break;
          case(departamentoPadraoEnum.LEGALIZACAO.id):
            departamentoId = this.verificarMatch(["Legalização", "Legalizacao"]);
            this.setDpPadraoConfig(departamentoPadraoId, departamentoId);
            break;
        }
      }
    },
    atualizarValoresSelects() {
      for(let dpConfig of this.configurados) {
        if(dpConfig.departamentoId == null) continue;
        const departamentoPadrao = this.departamentosPadraoFaltantes.find((dp) => dp.id == dpConfig.departamentoPadraoId);
        let slct = "select-"+departamentoPadrao.nome;
        this.$refs[slct][0].iniciarSelectComValor(dpConfig.departamentoId);
      }
    },
    setDpPadraoConfig(dpPadraoId, dpId) {
      let dpPadraoIndex = this.getDpConfigIndex(dpPadraoId);
      const dpPadrao = this.configurados[dpPadraoIndex];

      if(dpId == null) {
        if(!dpPadrao.departamentoId) {
          return;
        }

        const dpIndex = this.getDpIndex(dpPadrao.departamentoId);
        this.naoConfigurados[dpIndex].padrao = null;
        this.configurados[dpPadraoIndex].departamentoId = null;
        return;
      }

      const dpIndex = this.getDpIndex(dpId);
      if(this.configurados[dpPadraoIndex].departamentoId != null) return;
      this.configurados[dpPadraoIndex].departamentoId = dpId;
      this.naoConfigurados[dpIndex].padrao = dpPadraoId;
    },
    getDpPadraoConfigObj(departamentoPadraoId, departamentoId) {
      return {
        departamentoPadraoId,
        departamentoId
      };
    },
    inicializarDpNaoConfig() {
      if(this.naoConfigurados.length > 0) return;

      this.departamentos.forEach(dp => {
        if(dp.padrao == null) {
          this.naoConfigurados.push({ ...dp });
        }
      });
    },
    inicializarDpConfig() {
      if(this.configurados.length > 0) return;

      for(let i in departamentoPadraoEnum) {
        const id = departamentoPadraoEnum[i].id;
        if(!this.departamentosPadraoFaltantes.find(df => id == df.id)) {
          continue;
        }

        let departamentoPadraoConfigurado = this.getDpPadraoConfigObj(id, null);
        this.configurados.push(departamentoPadraoConfigurado);
      }
    },
    getDpConfigIndex(id) {
      return this.configurados.findIndex(dp => dp.departamentoPadraoId == id);
    },
    getDpIndex(id) {
      return this.naoConfigurados.findIndex(dp => dp.value == id);
    }
  },
  computed: {
    hasDepartamentos() {
      return this.naoConfigurados.length != 0
    },
    selectableOptions() {
      let obj = {};

      for(let i in departamentoPadraoEnum) {
        const id = departamentoPadraoEnum[i].id;
        obj[id] = this.naoConfigurados.filter(d => d.padrao == null || d.padrao == id);
      }

      return obj;
    }
  },
  watch: {
    configurados: {
      immediate: true,
      handler(novo, antigo) {
        if(novo == antigo) return;
        this.$emit('update:departamentosConfigurados', this.configurados);
      },
      deep: true
    },
    naoConfigurados: {
      immediate: true,
      handler(novo, antigo) {
        if(novo == antigo) return;
        this.$emit('update:departamentosNaoConfigurados', this.naoConfigurados);
      },
      deep: true
    }
  },
  mounted() {
    this.primeiroCarregamento = this.departamentosConfigurados.length == 0 && this.departamentosNaoConfigurados.length == 0;
    this.inicializarDpNaoConfig();
    this.inicializarDpConfig();
    this.preencherSelects();
  }
};
</script>

<style lang="scss" scoped>
.column.is-6 {
  padding: 0;
}
</style>